import { createContext, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux'; 
import { selectAuth, setAuthData, clearAuthData } from '../../store/auth/AuthSlice';

// ----------------------------------------------------------------------

const AuthContext = createContext(null);

function AuthProvider({ children }) {
  const dispatch = useDispatch();
  const auth = useSelector(selectAuth);

  const initialize = useCallback(async () => {
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      
      if (accessToken) {
      //  profile
        // dispatch(setAuthData()); 
        // const response = await axiosServices.get('/dealer-service/api/Account/get-account-info', {
        //   params: {
        //     idCompany: auth.idCompany,
        //     idDealer: auth.idDealer
        //   }
        // });

        // dispatch(setUserProfile(response.data.data));
        // console.log("token var");
      } 
      else 
      {
        // dispatch(clearAuthData()); 
        // console.log("token yok");
      }
    } catch (err) {
      // console.log("hataya düştü temizliyoruz");
      dispatch(clearAuthData());
      // dispatch(clearSalesData());
    }
  }, [dispatch]);

  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <AuthContext.Provider value={{ ...auth, initialize }}>
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
